module.exports = __webpack_public_path__ + "static/media/close-dark.5fbc9027.svg";